// DS5.10
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import ListMenu from '../LegacyListMenu';
import classnames from 'classnames';
import SubmitButton from './SubmitButton';
import SubmitMenuItem from './SubmitMenuItem';
import { desktopSubmitMenuItems } from '../../constants';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
import { Url } from '@wix/da-url';
import s from './SubmitMenu.scss';
const SubmitMenu = ({ className, menuClassName, isOpen, isLegacyHeader, toggleSubmitMenu })=>{
    const { t } = useTranslation();
    const isDsUpdate = useFlag('ds_update_btn_medium');
    const submitMenuItems = useMemo(()=>{
        return desktopSubmitMenuItems.map(({ type, label, target, verificationAction = 'submit', link, modalType, modalOptions, imageFileName, imageMarginBottom, imageMarginLeft, showNewByTitle, showDaProtect })=>{
            link = Url.buildFromPath(link); // only runtime can generate correct url on server
            return {
                key: label,
                renderElement: ()=>/*#__PURE__*/ React.createElement(SubmitMenuItem, {
                        role: "menuitem",
                        className: s['submit-menu-item'],
                        hoverComponentClassName: s['hover-component'],
                        type: type,
                        modalType: modalType,
                        modalOptions: modalOptions,
                        imageFileName: imageFileName,
                        imageMarginBottom: imageMarginBottom,
                        imageMarginLeft: imageMarginLeft,
                        label: label,
                        link: link,
                        target: target,
                        verificationAction: verificationAction,
                        showDaProtect: showDaProtect,
                        showNewByTitle: showNewByTitle,
                        isLegacyHeader: isLegacyHeader
                    })
            };
        });
    }, [
        isLegacyHeader
    ]);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isOpen && /*#__PURE__*/ React.createElement(TierCreatorReduxModule, null), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['submit-dropdown'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['submit-button-link-wrapper']
    }, /*#__PURE__*/ React.createElement(SubmitButton, {
        className: classnames(s['submit-button'], isOpen && s['submit-button-open'], isDsUpdate && s['submit-button-update']),
        onClick: toggleSubmitMenu,
        id: "site-header-submit-button"
    }, t('siteHeader.submit'))), /*#__PURE__*/ React.createElement("div", {
        className: s['submit-menu-wrapper']
    }, /*#__PURE__*/ React.createElement(ListMenu, {
        className: classnames(menuClassName, 'ds-surface-tertiary', s['submit-menu']),
        items: submitMenuItems,
        containerRole: "menu",
        "aria-labelledby": "site-header-submit-button"
    }))));
};
SubmitMenu.displayName = 'SubmitMenu';
export default SubmitMenu;

//# sourceMappingURL=SubmitMenu.js.map